import Loading from 'core/modules/atoms/Loading';
import SelectCustomizable from 'core/modules/atoms/SelectCustomizable';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TeacherLayoutWrapper from '../../components/layouts/TeacherLayoutWrapper/TeacherLayoutWrapper';
import InappropriateUseSection from './sections/InappropriateUseSection/InappropriateUseSection';
import './_teacher-ai-analytics-panel.scss';
import useTeacherAIAnalyticsPanel from './useTeacherAIAnalyticsPanel';

/**
 * TeacherAIAnalyticsPanelView - Main view for the AI analytics panel.
 * Displays class and time period filters with an empty content area for future phases.
 */
function TeacherAIAnalyticsPanelView(): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const { classOptions, selectedClass, setSelectedClass, timePeriodOptions, selectedTimePeriod, setSelectedTimePeriod, allCourseIds, groupCourseMap, loading } = useTeacherAIAnalyticsPanel();

  if (loading) {
    return <Loading />;
  }

  return (
    <TeacherLayoutWrapper activeNavigationId="analytics" sidebarMode="collapsed" showBackArrowWhenCollapsed={true} contentPadding="default">
      <div className="teacher-ai-analytics-panel">
        <div className="teacher-ai-analytics-panel__header">
          <div className="teacher-ai-analytics-panel__header-titles">
            <h1 className="teacher-ai-analytics-panel__title">{t('chatbot:ai_analytics_panel_title')}</h1>
            <p className="teacher-ai-analytics-panel__subtitle">{t('chatbot:ai_analytics_panel_subtitle')}</p>
          </div>
          <div className="teacher-ai-analytics-panel__header-filters">
            <div className="teacher-ai-analytics-panel__filter">
              <SelectCustomizable
                options={classOptions}
                value={selectedClass}
                onChange={(option: { label: string; value: string } | null) => option && setSelectedClass(option)}
                placeholder={t('chatbot:ai_analytics_select_class')}
                variant="default"
                size="default"
              />
            </div>
            <div className="teacher-ai-analytics-panel__filter">
              <SelectCustomizable
                options={timePeriodOptions}
                value={selectedTimePeriod}
                onChange={(option: { label: string; value: string } | null) => option && setSelectedTimePeriod(option)}
                placeholder={t('chatbot:ai_analytics_select_period')}
                variant="default"
                size="default"
              />
            </div>
          </div>
        </div>
        <div className="teacher-ai-analytics-panel__content">
          <InappropriateUseSection
            allCourseIds={allCourseIds}
            classValue={selectedClass.value}
            groupCourseMap={groupCourseMap}
            timePeriodValue={selectedTimePeriod.value}
          />
        </div>
      </div>
    </TeacherLayoutWrapper>
  );
}

export default TeacherAIAnalyticsPanelView;
